export enum UnitDataSources {
  UnitsNet = 1,
  OpenExchange = 2,
  Manual = 3,
  Climatiq = 4
}
